import { Account } from '@ndvr/portfolio-api';

import { useBrokerAccountPositions, useUniverseExcludedPositions } from '@/cip/api/position';
import { useAssetsByIdsMap } from '@/hooks/market-data-queries';

import { buildPolicyExclusions } from './policy-exclusions';
import { getPositionsStatus } from './PositionAmount';

export const usePolicyExclusions = (accounts: Account[]) => {
    const ids = accounts.flatMap((account) => (account.brokerAccountId ? [account.brokerAccountId] : []));
    const convictionIds = accounts.flatMap((account) =>
        (account.convictions ?? []).map((conviction) => conviction.securityId),
    );
    const positions = useBrokerAccountPositions(ids, { throwOnError: false });
    const unsupported = useUniverseExcludedPositions(ids);
    const assets = useAssetsByIdsMap(convictionIds, { throwOnError: false });
    return {
        retryQueries: [positions, unsupported, assets],
        rows: buildPolicyExclusions(accounts, assets.data, ids.length ? positions.data : [], unsupported.data ?? []),
        positionsStatus: getPositionsStatus(positions, ids.length > 0),
        isError: positions.isLoadingError || unsupported.isLoadingError,
        isPending: ids.length > 0 && (positions.isPending || unsupported.isPending),
        isAssetError: assets.isLoadingError,
    };
};
